<template>
    <router-link :to="{name: 'child.approvals', params: {child_id: notification.data.id}}" class="d-flex flex-row px-3 py-2 diary-likes e3-notification-row">
        <div class="profile-image-container">
            <ProfileImage :image-url="notification.creator.profile_picture" :name="notification.creator.name" size="sm"/>
        </div>
        <div class="d-flex flex-column ml-2 w-100">
            <div class="font-weight-bold">{{ notification.creator.name }}</div>
            <div class="text-break">
                {{ truncate(notificationText, 50) }}
            </div>
        </div>
    </router-link>
</template>

<script>
import {truncate} from '@/filters';

export default {
    name: 'ChildApprovalsSubmitNotification',
    props: {
        notification: Object
    },
    computed: {
        notificationText() {
            return this.$t('Notification - Child approvals', {child: this.notification.data.child_name});
        }
    },
    methods: {
        truncate // TODO: Vue3 remove
    }
};
</script>

<style scoped>

</style>
